import { useEffect, useState } from "react";
import axios from '../util/Axios';

export const useArmsData = (testId) => {

    const [armsData, setArmsData] = useState(null);

    useEffect(() => {

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                const armsResp = await axios(`/strokeTests/armMovements/${testId}`, { signal });
                setArmsData(armsResp.data);
            } catch (error) {
                if (error.message === 'CANCELLED') return;
                console.log(error)
            }
        };

        fetchData();

        return () => controller.abort();
    }, [testId]);

    return {armsData, setArmsData}

};